// extracted by mini-css-extract-plugin
module.exports = {"expansion":"Footer_expansion__IaP-c","container":"Footer_container__3brgb","links":"Footer_links__16A5O","ready":"Footer_ready__3D1C-","copyright":"Footer_copyright__3wZ89"};